import React from "react"

export function PatternFish({ className }: { className?: string }) {
  return (
    <div className={className} style={{ maskImage: 'radial-gradient(black, transparent)' }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="opacity-[0.03] dark:opacity-[0.05]"
      >
        <defs>
          <pattern
            id="fish-pattern"
            x="0"
            y="0"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            {/* Stylized Fish Scale / Búzios Wave Pattern */}
            <path
              d="M0 20 C 10 10, 30 10, 40 20 C 30 30, 10 30, 0 20 Z"
              fill="currentColor"
              transform="translate(0, 5) scale(0.8)"
            />
            <path
              d="M0 20 C 10 10, 30 10, 40 20 C 30 30, 10 30, 0 20 Z"
              fill="currentColor"
              transform="translate(20, 25) scale(0.8)"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#fish-pattern)" />
      </svg>
    </div>
  )
}
